/*
 * theme-lite.js: what theme.js does on the homepage and theme pages, without jQuery. layout/theme.liquid loads it
 * instead of jquery.min.js, vendor.js and theme.js there (see tv_theme_lite); every other page and the theme editor
 * keep theme.js. Each block below names the theme.js code it stands for, so a change to one is mirrored in the other.
 * Needs theme-core.js (wishlist, deferMenuTemplates, tvMotion) and, for the promotion bar, Swiper through
 * theme-asset-loader.js.
 */
(function() {
  window.theme = window.theme || {};
  var theme = window.theme;
  var motion = window.tvMotion;

  function each(selector, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(selector), fn);
  }

  /** jQuery's $tg.parents().is(selector): an ancestor of the target (not the target itself) matches. */
  function insideAncestor(target, selector) {
    return !!(target.parentElement && target.parentElement.closest(selector));
  }

  function matches(target, selector) {
    return !!(target.matches && target.matches(selector));
  }

  function dataJson(el, name) {
    var raw = el.getAttribute('data-' + name);
    if (raw === null) return undefined;
    try { return JSON.parse(raw); } catch (error) { return raw; }
  }

  /* theme.HeaderSection: header-fresh renders none of the old mobile-nav hooks, so only search and the outside
     click remain. */
  function initHeader() {
    if (theme.Search && typeof theme.Search.init === 'function') theme.Search.init();
    document.body.addEventListener('click', function(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!insideAncestor(target, '.main-search') && !insideAncestor(target, '.searchinline') && !matches(target, '.searchIcn') && !insideAncestor(target, '.leftcol')) {
        each('.main-search .s_res, .searchinline .s_res, .hdSearch  .s_res', function(el) { motion.fadeOut(el); });
      }
      if (!insideAncestor(target, '#LanguageForm') && !matches(target, '.sl-lang')) {
        motion.fadeOut(document.getElementById('language'));
      }
      if (!insideAncestor(target, '#currency-picker') && !matches(target, '.selected-currency')) {
        motion.fadeOut(document.getElementById('currencies'));
      }
    });
  }

  /* theme.Quotes: the promotion bar carousel (only rendered with more than one message). */
  function initQuotes(container) {
    var sectionId = container.getAttribute('data-section-id');
    var slider = document.getElementById('Quotes-' + sectionId);
    if (!slider || typeof window.Swiper !== 'function') return;
    var swiper = new window.Swiper('#Quotes-' + sectionId, {
      loop: true,
      slidesPerView: 'auto',
      effect: dataJson(slider, 'effect'),
      autoplay: dataJson(slider, 'autoplay'),
      pagination: { el: '.swpg' + sectionId, clickable: true },
      navigation: { nextEl: '.swn' + sectionId, prevEl: '.swp' + sectionId }
    });
    swiper.on('slideChange', function() {
      each('#Quotes-' + sectionId + ' .swiper-slide-duplicate .bgImg.lazyloading', function(el) { el.classList.add('lazyload'); });
    });
  }

  /* theme.countdown */
  function countdown() {
    each('.saleTime, .atCounter', function(el) {
      var target = new Date(el.getAttribute('data-date')).getTime();
      var pad = function(value, size) { return ('00' + value).substr(-size); };
      var set = function(selector, value) { each(selector, function(node) { node.innerHTML = value; }, el); };
      var timer = setInterval(function() {
        var distance = target - new Date().getTime();
        var days = Math.floor(distance / 864e5);
        set('.days', days > 99 ? pad(days, 3) : pad(days, 2));
        set('.hours', pad(Math.floor(distance % 864e5 / 36e5), 2));
        set('.minutes', pad(Math.floor(distance % 36e5 / 6e4), 2));
        set('.seconds', pad(Math.floor(distance % 6e4 / 1e3), 2));
        if (distance < 0) {
          clearInterval(timer);
          el.style.display = 'none';
          var line = el.parentElement && el.parentElement.closest('.timerl');
          if (line) line.style.display = 'none';
        }
      }, 1000);
    });
  }
  theme.countdown = countdown;

  /* slate.rte and slate.a11y.pageLinkFocus */
  function wrap(el, className) {
    var box = document.createElement('div');
    box.className = className;
    el.parentNode.insertBefore(box, el);
    box.appendChild(el);
  }

  function pageLinkFocus(el) {
    if (!el) return;
    el.setAttribute('tabIndex', '-1');
    el.focus();
    el.classList.add('js-focus-hidden');
    el.addEventListener('blur', function() {
      el.classList.remove('js-focus-hidden');
      el.removeAttribute('tabindex');
    }, { once: true });
  }

  function hashTarget(hash) {
    return hash && hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
  }

  /* theme.init */
  function init() {
    theme.wishlist.sync();
    each('.rte table', function(el) { wrap(el, 'tb-wrap'); });
    each('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]', function(el) {
      wrap(el, 'vd-wrap');
      el.src = el.src;
    });
    each('.rte iframe#admin_bar_iframe', function(el) { el.src = el.src; });
    theme.deferMenuTemplates();
    countdown();
    pageLinkFocus(hashTarget(window.location.hash));
    each('.in-page-link', function(el) {
      el.addEventListener('click', function(event) { pageLinkFocus(hashTarget(event.currentTarget.hash)); });
    });
    each('a[href="#"]', function(el) {
      el.addEventListener('click', function(event) { event.preventDefault(); });
    });
    each('#currencies li', function(el) {
      el.addEventListener('click', function() {
        if (document.documentElement.clientWidth > 999) motion.slideUp(document.getElementById('currencies'));
      });
    });

    // Mega menu tabs (m6 menus).
    var navTabSelector = '.mm6main a[data-link], .cm6main a[data-link]';
    var hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    var activateMegaMenuTab = function(link) {
      var target = link.getAttribute('data-link');
      if (!target) return;
      var menu = link.closest('.mm6main, .cm6main');
      if (menu) each('a.active', function(el) { el.classList.remove('active'); }, menu);
      link.classList.add('active');
      var panel = document.querySelector(target);
      if (panel) {
        panel.classList.add('active');
        Array.prototype.forEach.call(panel.parentNode.children, function(sibling) {
          if (sibling !== panel && sibling.classList.contains('admmsub')) sibling.classList.remove('active');
        });
      }
    };
    document.addEventListener('focusin', function(event) {
      var link = event.target instanceof Element && event.target.closest(navTabSelector);
      if (link) activateMegaMenuTab(link);
    });
    document.addEventListener('mouseover', function(event) {
      if (!hoverMedia.matches) return;
      var link = event.target instanceof Element && event.target.closest(navTabSelector);
      if (link && !link.classList.contains('active') && !link.contains(event.relatedTarget)) activateMegaMenuTab(link);
    });
  }

  /* Language and currency picker (theme.init) */
  document.addEventListener('click', function(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var toggle = target.closest('.crlgTtl');
    if (toggle) {
      event.preventDefault();
      motion.slideToggle(toggle.nextElementSibling);
      return;
    }
    var option = target.closest('.clOtp');
    if (option) {
      var form = option.closest('form');
      if (!form) return;
      each('.slcrlg', function(input) { input.value = option.getAttribute('data-value'); }, form);
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    }
  });

  /* theme.ajaxCart: quick view and quick shop open the React quick view, else go to the product page. */
  function quickViewProductHref(trigger) {
    var raw = trigger && trigger.getAttribute('href');
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin || !/^(\/[a-z]{2}(-[a-z]{2})?)?\/products\/[^\/]+$/i.test(url.pathname)) return '';
      url.search = '';
      url.hash = '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function openReactQuickView(trigger) {
    var bridge = window.tvInteractions && window.tvInteractions.open;
    var productId = trigger && trigger.getAttribute('data-product-id');
    var staticViewCardId = trigger && trigger.getAttribute('data-static-view-card-id');
    var fallbackHref = trigger && trigger.getAttribute('href');
    if (typeof bridge !== 'function' || !productId) return false;
    return bridge({ kind: 'quick-view', productId: productId, source: 'page_item', fallbackHref: fallbackHref || '',
      context: { staticViewCardId: staticViewCardId || undefined, pageType: 'theme-quick-view' } }) === true;
  }

  function initAjaxCart() {
    document.body.addEventListener('click', function(event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('.modalOverly')) {
        each('.modal', function(el) { motion.fadeOut(el, 200); });
        document.body.classList.remove('loading', 'showOverly');
      }
      var trigger = target.closest('.quick-view,.quickShop');
      if (!trigger) return;
      if (openReactQuickView(trigger)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      var productHref = quickViewProductHref(trigger);
      if (productHref) {
        event.preventDefault();
        window.location.assign(productHref);
      }
    });
    document.addEventListener('click', function(event) {
      var trigger = event.target instanceof Element && event.target.closest('.quickShop');
      if (!trigger || openReactQuickView(trigger)) return;
      each('.ctdrawer', function(el) { el.classList.add('poptop'); });
    });
    theme.wishlist.init();
  }

  /* Sticky header, back to top (theme.js document ready) */
  function initScroll() {
    var header = document.querySelector('.hdr_wrap');
    var scrollTop = function() { return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0); };
    var lastScroll = scrollTop();
    var headerTop = header ? header.getBoundingClientRect().top + lastScroll : 0;
    var headerHeight = header ? header.clientHeight : 0;
    var scrollDirection = null;
    var directionStart = lastScroll;
    var ticking = false;
    var toTop = document.getElementById('scroll_top');

    function stickyHeader(scroll) {
      if (!header) return;
      if (theme.stickyHeader == 'top') {
        if (scroll <= headerHeight) {
          header.classList.remove('sticky_hdr', 'animated', 'fadeInDown');
          scrollDirection = null;
          directionStart = scroll;
          lastScroll = scroll;
          return;
        }
        var delta = scroll - lastScroll;
        if (Math.abs(delta) < 2) return;
        var nextDirection = delta > 0 ? 'down' : 'up';
        if (nextDirection !== scrollDirection) {
          scrollDirection = nextDirection;
          directionStart = lastScroll;
        }
        if (nextDirection == 'down' && scroll - directionStart >= 8) {
          header.classList.remove('sticky_hdr', 'animated', 'fadeInDown');
        } else if (nextDirection == 'up' && directionStart - scroll >= (window.matchMedia('(max-width: 749px)').matches ? 40 : 12)) {
          header.classList.add('sticky_hdr', 'animated', 'fadeInDown');
        }
        lastScroll = scroll;
      } else if (theme.stickyHeader == 'always') {
        header.classList.toggle('sticky_hdr', scroll > headerTop);
      }
    }

    function update() {
      var scroll = scrollTop();
      stickyHeader(scroll);
      if (toTop) toTop.classList.toggle('active', scroll > 200);
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    if (toTop) {
      toTop.addEventListener('click', function(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* Footer link groups fold below 769px */
  function initFooter() {
    each('.f_links .h4', function(heading) {
      heading.addEventListener('click', function() {
        if (document.documentElement.clientWidth >= 769) return;
        heading.classList.toggle('active');
        motion.slideToggle(heading.nextElementSibling);
      });
    });
  }

  /* theme.Sections: only the two section types these pages render. */
  function registerSections() {
    each('[data-section-type="header"]', function() { initHeader(); });
    each('[data-section-type="quotes"]', initQuotes);
  }

  function start() {
    initAjaxCart();
    registerSections();
    init();
    initScroll();
    initFooter();
  }

  // A deferred script runs while readyState is already 'interactive' but before DOMContentLoaded, and before the
  // deferred scripts after it (theme-search-drawer.js defines theme.Search), so wait for DOMContentLoaded.
  if (document.readyState === 'complete') start(); else document.addEventListener('DOMContentLoaded', start);
})();
